// extracted by mini-css-extract-plugin
module.exports = {"column-transfer":"column-transfer","column":"column"};